import { createAction, props } from '@ngrx/store';

export const SetLoginTypeAction = createAction('[Login] Set LoginType', props<{ loginType: string }>());
export const SetLoginStatusAction = createAction('[Login] Set LoginStatus', props<{ loginStatus: boolean }>());
